import { CHECKWORK_WSPOS, CHECKWORK_WSPOS_SUCCESSFUL, CHECKWORK_WSPOS_FAILED } from './actionTypes';

export const checkWorkWSPosition = (ws_pos, value,token, history) => {
    return {
        type: CHECKWORK_WSPOS,
        payload: { ws_pos, value, token, history }
    }
}

export const checkWorkWSPositionSuccessful = (msg) => {
    return {
        type: CHECKWORK_WSPOS_SUCCESSFUL,
        payload: msg
    }
}

export const checkWorkWSPositionFailed = (msg) => {
    return {
        type: CHECKWORK_WSPOS_FAILED,
        payload: msg
    }
}
